import styled, { css } from 'styled-components';

export default styled.div`
  width: 100%;
  height: 2px;
  background-color: #8e90b3;
  transition-property: background-color;
  transition-duration: 0.3s;

  ${props => props.isActive && css`
    background-color: #112f47;
  `}
`;
